import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ErrorCode } from "react-dropzone";
export const DZErrors = ({ errorCodes, maxFiles, maxSize, }) => {
    const [invalidFileType, setInvalidFileType] = useState(false);
    const [fileTooLarge, setFileTooLarge] = useState(false);
    const [fileTooSmall, setFileTooSmall] = useState(false);
    const [tooManyFiles, setTooManyFiles] = useState(false);
    useEffect(() => {
        errorCodes.forEach((err) => {
            switch (err) {
                case ErrorCode.FileInvalidType:
                    setInvalidFileType(true);
                    break;
                case ErrorCode.FileTooLarge:
                    setFileTooLarge(true);
                    break;
                case ErrorCode.FileTooSmall:
                    setFileTooSmall(true);
                    break;
                case ErrorCode.TooManyFiles:
                    setTooManyFiles(true);
                    break;
                default:
                    break;
            }
        });
    }, [errorCodes, tooManyFiles]);
    return (_jsxs("div", { className: "mt-2", children: [invalidFileType && (_jsx("div", { className: "text-error dark:text-dark-error mb-2 text-sm", children: "Please select a valid file type" })), fileTooLarge && (_jsxs("div", { className: "text-error dark:text-dark-error mb-2 text-sm", children: ["File size exceeds ", maxSize / Math.pow(1024, 2), " MB limit"] })), fileTooSmall && (_jsx("div", { className: "text-error dark:text-dark-error mb-2 text-sm", children: "File size too small" })), tooManyFiles && (_jsxs("div", { className: "text-error dark:text-dark-error mb-2 text-sm", children: ["You can only upload up to ", maxFiles, " ", maxFiles !== undefined && maxFiles > 1 ? "files" : "file", " at a time"] }))] }));
};
export default DZErrors;
